/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import TextInput from "@/components/hookForms/textField";
import AutoComplete from "@/components/hookForms/autoComplete";
import messages from "@/utils/messages";
import { Title } from "@/components/title/style";

import serviceModeloFatura from "@/services/serviceModeloFatura";
import { LoadingButton } from "@mui/lab";
import { tipoDadoOptions } from "@/utils/constants";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data?: any;
}
const Modal: React.FC<IDialogProps> = ({ open, onClose, data, onSuccess }) => {
    const [isDisable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const validationSchema = yup.object().shape({
        descricaoChave: yup.string().required(messages.requiredField),
        tipoDado: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            descricaoChave: "",
            tipoDado: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);
        setLoading(true);

        const newValues = {
            ...values,
            descricaoFaturaValoresID: data.descricaoFaturaValoresID,
        };

        serviceModeloFatura
            .updateAtributo(newValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    reset();
                    onClose();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setLoading(false);
                setDisable(false);
            });
    };

    return (
        <Box>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <Title>Editar Campo da Fatura</Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextInput
                                    id="descricaoChave"
                                    name="descricaoChave"
                                    label="Descrição Chave"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <AutoComplete
                                    id="tipoDado"
                                    name="tipoDado"
                                    label="Tipo Dado"
                                    options={tipoDadoOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            type="submit"
                            color="primary"
                            variant="contained"
                            loading={isLoading}
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    );
};

export default Modal;
